import axios from 'axios';

const API_URL=process.env.VUE_APP_API_URL;
import authHeader from "@/services/auth-header";

class DoctorService {

    createDoctor(form){
        return form.post(`${API_URL}/doctors/approve`, {headers: authHeader()});
    }

    approveDoctorRequest(doctor_id,activation_status_form){
        return activation_status_form.put(`${API_URL}/doctors/${doctor_id}/approve`,{headers: authHeader()});
    }

    makePayment(form){
        return form.post(`${API_URL}/doctorpayments`, {headers: authHeader()});
    }

    fetchPaginatedDoctorRequests(page_number){
        return axios.get(`${API_URL}/doctors/pending?page=${page_number}` , {headers: authHeader()});
    }
    fetchDoctorTypes(){
        return axios.get(`${API_URL}/doctortypes`);
    }

    fetchApprovedDoctors(page_number){
        return axios.get(`${API_URL}/doctors/approved?page=${page_number}`);
    }
}

export default new DoctorService();